import React from 'react';
import { Link } from 'react-router-dom';
import { slideToggle } from './../../composables/slideToggle.js';
import { useDispatch } from 'react-redux';
import { Logout } from '../../../src/actions/auth_actions.js';
import  useIsDarkTheme from './useIsDarkTheme.jsx';

function Header() {
  const dispatch = useDispatch();
  const username = localStorage.getItem("email");
  const isDark = useIsDarkTheme(); // Just use the hook!


  const email = localStorage.getItem('email') || '';
  const initial = email.charAt(0).toUpperCase();

  // ...other functions unchanged...

  const toggleAppSidebarDesktop = () => {
    const elm = document.querySelector('.app');
    if (elm) {
      if (!(elm.classList.contains('app-with-top-nav') && elm.classList.contains('app-without-sidebar'))) {
        elm.classList.toggle('app-sidebar-collapsed');
        setTimeout(() => window.dispatchEvent(new Event('resize')), 150);
      }
    }
  };

  const toggleAppSidebarMobile = () => {
    const elm = document.querySelector('.app');
    if (elm) {
      if (!(elm.classList.contains('app-with-top-nav') && elm.classList.contains('app-without-sidebar'))) {
        elm.classList.toggle('app-sidebar-mobile-toggled');
      } else {
        slideToggle(document.querySelector('.app-top-nav'));
      }
    }
  };

  const toggleAppHeaderSearch = () => {
    const elm = document.querySelector('.app');
    elm.classList.toggle('app-header-menu-search-toggled');
  };

  return (
    <div id="header" className="app-header">
      <div className="desktop-toggler">
        <button type="button" className="menu-toggler" onClick={toggleAppSidebarDesktop}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
      <div className="mobile-toggler">
        <button type="button" className="menu-toggler" onClick={toggleAppSidebarMobile}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
      <div className="brand" style={{ width: 400 }}>
        <Link to="/" className="brand-logo">
          <img
            src={isDark ? "/assets/img/barsys_hori.svg" : "/assets/img/Barsys_dark.png"}
            alt="Barsys Logo"
            style={{ height: 20, width: "auto", display: "block" }}
          />
          <span className="brand-text" style={{ paddingTop: 5 }}>ANALYTICS DASHBOARD</span>
        </Link>
      </div>
      <div className="menu">
        {/* ...your existing menu code... */}
        <div className="menu-item dropdown dropdown-mobile-full">
          <a href="#/" data-bs-toggle="dropdown" data-bs-display="static" className="menu-link">
            {/* OLD:
            <div className="menu-img online">
              <img src="/assets/img/user/profile.jpg" alt="Profile" height="60" />
            </div>
            */}
            <div
              className="menu-img online d-flex align-items-center justify-content-center rounded-circle"
              style={{
                backgroundColor: 'var(--bs-theme)',  // or your theme color CSS variable
                width: '25px',
                height: '25px',
                fontSize: '1.1rem',
              }}
            >
              <span style={{ color: '#d3d3d3' }}>{initial}</span>
            </div>
            <div className="menu-text d-sm-block d-none w-170px">
              {email}
            </div>
          </a>
          <div className="dropdown-menu dropdown-menu-end me-lg-3 fs-11px mt-1">
            <Link to="/settings" className="dropdown-item d-flex align-items-center">
              SETTINGS <i className="bi bi-gear ms-auto text-theme fs-16px my-n1"></i>
            </Link>
            <div className="dropdown-divider"></div>
            <Link
              to="/login"
              className="dropdown-item d-flex align-items-center"
              onClick={() => dispatch(Logout())}
            >
              LOGOUT <i className="bi bi-toggle-off ms-auto text-theme fs-16px my-n1"></i>
            </Link>
          </div>
        </div>
      </div>
      {/* ...search form unchanged... */}
    </div>
  );
}

export default Header;
